<template>
  <v-app>
    <core-app-bar />

    <v-content>
      <v-img
        height="100%"
        :src="require('@/assets/docs-background.jpg')"
        gradient="to bottom right, rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.42)"
      >
        <div class="py-12 my-12">
          <router-view />
        </div>
      </v-img>
    </v-content>

    <core-footer />
  </v-app>
</template>

<script>
  export default {
    components: {
      CoreFooter: () => import('@/components/core/Footer'),
      CoreAppBar: () => import('@/components/core/AppBar')
    }
  }
</script>
